import React from 'react';
import HeaderLogged from './components/header_logged';
import Container from './components/container';
import { Link } from 'react-router-dom';
import { usePermissions } from './PermissionsContext';

const ITEMS = [
    { page: 'scanner-inv-seeds',         to: '/scannerinvseeds',            label: 'Inventory Seeds' },
    { page: 'scanner-inv-fert',          to: '/scannerinvfert',             label: 'Inventory Fertilizers' },
    { page: 'scanner-seeds-stock-check', to: '/scannerinvseedsstockcheck',  label: 'Seeds Inventory Check' },
    { page: 'scanner-inv-materials',     to: '/scannerainvmaterials',       label: 'Inventory Small Bags' },
    { page: 'scanner-not-full-boxes',    to: '/scannernotfullboxes',        label: 'Inventory Not Full Boxes Small Bags' },
    { page: 'scanner-sealed-sets',       to: '/scannersealedsets',          label: 'Boxes with Sealed Products' },
    { page: 'scanner-unsealed-sets',     to: '/scannerunsealedsets',        label: 'Transfer Unsealed Products' },
    { page: 'scanner-shipments',         to: '/scannershipments',           label: 'SS Shipments' },
    { page: 'scanner-amazon-shipments',  to: '/scanners-amazon-shipments',  label: 'FBA Shipments' },
    { page: 'orders-scan',               to: '/orders-scan',                label: 'Orders' },
    { page: 'get-labels',                to: '/get-labels',                 label: 'Get Labels, Barcodes' },
];

const ScannersMenu = () => {
    const { can } = usePermissions();

    return (
        <div>
            <HeaderLogged />
            <Container>

                <div className="text-center scanners-menu" style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', margin: '200px 0 0 0' }}>
                    {ITEMS.filter(item => can(item.page)).map(item => (
                        <Link key={item.page} className="scannersmenu-item" to={item.to} style={{ flex: '1 1 45%' }}>{item.label}</Link>
                    ))}
                </div>
            </Container>
        </div>
    );
};

export default ScannersMenu;
